
export function isDataBinding(data: any) {
    return typeof data === 'object' && data && data.type === 'DataBinding';
}
